import React, { useContext } from "react";
import { CommandBarButton, Theme, useDisclosure } from "sprint-common-web";

import { OrderStatus } from "../../../common/types/OrderStatus";
import { OrderDashboardContext } from "../../dashboard/provider/OrderDashboardContext";
import { RejectOrderModal } from "../RejectOrderModal";

export const RejectOrderButton: React.VFC = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { orderId, orderDashboardItem, isLoading, reject } = useContext(OrderDashboardContext);

    const { status } = orderDashboardItem;

    const handleReject = async () => {
        reject();

        onClose();
    };

    const isRejectEnabled =
        !isLoading &&
        (status === OrderStatus.Pending ||
            status === OrderStatus.EncodingFailed ||
            status === OrderStatus.Encoded ||
            status === OrderStatus.DeliveryFailed) &&
        !orderDashboardItem.buzzId;

    return (
        <>
            <RejectOrderModal isOpen={isOpen} onCancel={onClose} onSubmit={handleReject} orderId={orderId} />
            <CommandBarButton
                text="Reject"
                styles={{ root: { background: Theme.palette.neutralLighterAlt } }}
                disabled={!isRejectEnabled}
                icon="RemoveFilter"
                onClick={onOpen}
                testId={"reject-order-button"}
            />
        </>
    );
};
